import {createContext} from 'react'

export const WebVisitorsContext = createContext({
  visitors: [],
  isLoading: false,
  onSearch: (value: string) => {},
  onSortingChange: (key: string, order: string) => {},
})
